// Purchase Order checkout gate. See sources/docs/cart-b2b-input.md.

(function() {
  if (window.__lindyPoGate) return;
  window.__lindyPoGate = true;

  // Upload state: Cloudlift events, seeded from cart attributes on page load.
  const SELECTOR = '[data-lindy-po-number]';
  const uploadedFiles = new Set();
  let seededUpload = false;
  // Server's has-upload flag is stale after a removal.
  let seedRevoked = false;
  let saveTimeout = null;
  // Latched: stays required even if a re-render drops the section.
  let poRequired = false;

  function latchPoRequired() {
    if (document.querySelector('[data-po-required]')) poRequired = true;
  }

  function instances() {
    return document.querySelectorAll(SELECTOR);
  }

  function hasUpload() {
    return uploadedFiles.size > 0 || seededUpload;
  }

  function reseedUpload() {
    seededUpload = !seedRevoked && !!document.querySelector(SELECTOR + '[data-po-has-upload="true"]');
  }

  function trackUploadEvent(eventName, adds) {
    window.addEventListener(eventName, function(e) {
      const container = e.target && e.target.closest && e.target.closest(SELECTOR);
      const file = e.detail;
      if (!container || !file || !file.url) return;

      if (adds) {
        uploadedFiles.add(file.url);
      } else {
        uploadedFiles.delete(file.url);
        seedRevoked = true;
        seededUpload = false;
      }

      updateAll();
    });
  }

  trackUploadEvent('upload:added', true);
  trackUploadEvent('upload:removed', false);

  function checkoutButtonFor(container) {
    const id = container.getAttribute('data-checkout-target');
    return id ? document.getElementById(id) : null;
  }

  // Compared as values, not a selector, so an odd id can't throw.
  function containerForCheckoutButton(button) {
    if (!button.id) return null;
    return Array.from(instances()).find(function(container) {
      return container.getAttribute('data-checkout-target') === button.id;
    }) || null;
  }

  function isCheckoutAllowed(container) {
    const optout = container.querySelector('[data-po-optout]');
    if (optout && optout.checked) return true;
    const poInput = container.querySelector('[data-po-input]');
    return !!(poInput && poInput.value.trim()) && hasUpload();
  }

  function updateUI(container) {
    const poInput = container.querySelector('[data-po-input]');
    const optout = container.querySelector('[data-po-optout]');
    const optedOut = !!(optout && optout.checked);

    if (poInput) {
      poInput.disabled = optedOut;
      if (optedOut) poInput.value = '';
    }

    const allowed = isCheckoutAllowed(container);
    const button = checkoutButtonFor(container);
    // Leave alone mid-submit.
    if (button && !button.hasAttribute('data-po-submitting')) {
      // Clickable but aria-disabled, so a click can show the error.
      button.disabled = false;
      if (allowed) {
        button.removeAttribute('aria-disabled');
      } else {
        button.setAttribute('aria-disabled', 'true');
      }
      button.classList.toggle('button--disabled', !allowed);
    }

    if (allowed) {
      const error = container.querySelector('[data-po-error]');
      if (error) error.hidden = true;
    }

    // Express checkout skips the cart form, so hide it.
    const target = container.getAttribute('data-checkout-target');
    document.querySelectorAll('[data-po-express-checkout]').forEach(function(node) {
      if (node.getAttribute('data-po-express-checkout') === target) node.hidden = !allowed;
    });
  }

  function updateAll() {
    instances().forEach(updateUI);
  }

  // Both instances post via the same #cart-form - keep them in sync.
  function syncInstances(source) {
    const poInput = source.querySelector('[data-po-input]');
    const optout = source.querySelector('[data-po-optout]');

    instances().forEach(function(other) {
      if (other === source) return;
      const otherInput = other.querySelector('[data-po-input]');
      const otherOptout = other.querySelector('[data-po-optout]');
      if (poInput && otherInput) otherInput.value = poInput.value;
      if (optout && otherOptout) otherOptout.checked = optout.checked;
    });
  }

  function saveAttributes(container, callback) {
    clearTimeout(saveTimeout);

    const poInput = container.querySelector('[data-po-input]');
    const optout = container.querySelector('[data-po-optout]');
    const poValue = poInput && !poInput.disabled ? poInput.value.trim() : '';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Purchase Order Number': poValue,
          'Account Payment Opt-out': optout && optout.checked ? 'Yes' : ''
        }
      })
    })
    .then(r => r.json())
    .then(() => callback && callback())
    .catch(() => callback && callback());
  }

  // Emptied carts keep their attributes - clear leftovers.
  function clearStaleAttributes() {
    const marker = document.querySelector('[data-po-stale-attributes]');
    if (!marker) return;
    marker.remove();

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Purchase Order Number': '',
          'Account Payment Opt-out': '',
          'Purchase Order Document': '',
          'upload': ''
        }
      })
    }).catch(() => {});
  }

  function showPoError(container) {
    const disclosure = container.closest('disclosure-custom');
    const trigger = disclosure && disclosure.querySelector('.disclosure-trigger');
    if (trigger && trigger.getAttribute('aria-expanded') !== 'true') trigger.click();

    const error = container.querySelector('[data-po-error]');
    if (error) error.hidden = false;

    (disclosure || container).scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  // Cloudlift only scans on page load and setup() isn't safe to repeat: once per page, new containers only.
  let uploadSetupDone = false;
  let uploadSetupChecked = false;
  let uploadSetupWaited = false;
  let uploadSetupRetries = 0;
  let uploadSetupTimer = null;

  function retryUploadSetup(delay) {
    if (uploadSetupTimer || uploadSetupRetries >= 20) return;
    uploadSetupRetries++;
    uploadSetupTimer = setTimeout(function() {
      uploadSetupTimer = null;
      mountUploadWidget();
    }, delay);
  }

  function mountUploadWidget() {
    if (uploadSetupDone) return;

    const mounts = document.querySelectorAll('[data-po-upload-mount]');
    if (!uploadSetupChecked) {
      uploadSetupChecked = true;
      if (mounts.length) {
        uploadSetupDone = true;
        return;
      }
    }
    if (!mounts.length) return;

    for (const mount of mounts) {
      if (mount.firstElementChild) {
        uploadSetupDone = true;
        return;
      }
    }

    const app = window.Cloudlift && window.Cloudlift.upload && window.Cloudlift.upload.App;
    if (!app || typeof app.setup !== 'function') {
      // Embed loads async.
      uploadSetupWaited = true;
      retryUploadSetup(250);
      return;
    }

    if (uploadSetupWaited) {
      // Let Cloudlift's own load scan go first.
      uploadSetupWaited = false;
      retryUploadSetup(1000);
      return;
    }

    uploadSetupDone = true;
    app.setup();
  }

  function closest(node, selector) {
    return node && node.closest ? node.closest(selector) : null;
  }

  document.addEventListener('input', function(e) {
    const container = closest(e.target, SELECTOR);
    if (!container || !e.target.matches('[data-po-input]')) return;

    syncInstances(container);
    updateAll();
    clearTimeout(saveTimeout);
    saveTimeout = setTimeout(function() {
      saveAttributes(container);
    }, 500);
  });

  document.addEventListener('change', function(e) {
    const container = closest(e.target, SELECTOR);
    if (!container || !e.target.matches('[data-po-optout]')) return;

    syncInstances(container);
    updateAll();
    saveAttributes(container);
  });

  document.addEventListener('blur', function(e) {
    const container = closest(e.target, SELECTOR);
    if (!container || !e.target.matches('[data-po-input]')) return;
    saveAttributes(container);
  }, true);

  // Delegated capture, so re-rendered buttons stay gated.
  document.addEventListener('click', function(e) {
    const button = closest(e.target, 'button[name="checkout"]');
    if (!button) return;

    try {
      handleCheckoutClick(e, button);
    } catch (error) {
      // Fail closed on unexpected errors.
      if (poRequired) e.preventDefault();
      throw error;
    }
  }, true);

  function handleCheckoutClick(e, button) {
    // Any instance can answer - attributes are cart-level.
    const container = containerForCheckoutButton(button) || instances()[0] || null;

    if (!container) {
      // No section to check: fail closed for B2B.
      if (!poRequired) return;

      e.preventDefault();
      e.stopPropagation();
      alert('Please enter a Purchase Order Number and upload a document, or select "I don\'t want to use Account Payment"');
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    if (!isCheckoutAllowed(container)) {
      showPoError(container);
      return;
    }

    const cartForm = button.form || document.querySelector('#cart-form');
    button.setAttribute('data-po-label', button.textContent);
    button.setAttribute('data-po-submitting', '');
    button.disabled = true;
    button.textContent = 'Processing...';

    saveAttributes(container, function() {
      if (cartForm) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'checkout';
        input.setAttribute('data-po-checkout-input', '');
        cartForm.appendChild(input);
        cartForm.submit();
      } else {
        window.location.href = '/checkout';
      }
    });
  }

  function refresh() {
    latchPoRequired();
    clearStaleAttributes();
    reseedUpload();
    updateAll();
    mountUploadWidget();
  }

  // Re-apply after cart updates and DOM changes (async re-renders, morphs restoring `disabled`).
  document.addEventListener('cart:update', function() {
    setTimeout(refresh, 0);
  });

  let refreshQueued = false;
  new MutationObserver(function() {
    if (refreshQueued) return;
    refreshQueued = true;
    requestAnimationFrame(function() {
      refreshQueued = false;
      refresh();
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled']
  });

  // Back/forward cache: undo the mid-submit state.
  window.addEventListener('pageshow', function(e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-po-checkout-input]').forEach(function(input) {
      input.remove();
    });
    document.querySelectorAll('[data-po-submitting]').forEach(function(button) {
      button.removeAttribute('data-po-submitting');
      if (button.hasAttribute('data-po-label')) button.textContent = button.getAttribute('data-po-label');
    });
    refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
